import HomePage from 'components/HomePage/HomePage'

export default HomePage
